import { render, staticRenderFns } from "./EntityFromConfig.vue?vue&type=template&id=35457056&scoped=true&"
import script from "./EntityFromConfig.vue?vue&type=script&lang=js&"
export * from "./EntityFromConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35457056",
  null
  
)

export default component.exports